import React from "react";
import Title from "../home/Title";
import ResumeCard from "../resume/ResumeCard";

const Education = () => {
  return (
    <section id="resume">
      <Title title="My" subTitle="Education" />
      <div className="w-full grid grid-cols-3 px-8">
        <div className="col-span-9 md:col-span-4">
          <ResumeCard
            duration="Oct 2019-Oct 2023"
            title="Bachelor's Degree in Computer System Engineering"
            link="https://drive.google.com/file/d/1pDjKy14779CxuDiBWMBJO_XPk5BlkAdk/view?usp=sharing"
            subTitle="NED University Of Engineering & Technology"
            des="Coursework: Data Structures and Algorithms, Software Engineering, Machine Learning & Artificial Intelligence. Final Year Project: Sign Language Recognition App, Two-way sign language recognition system using React Native, CNN and Flask."
          />
        </div>
      </div>
      <Title title="Certificates &" subTitle="Training" />
      <div className="w-full grid grid-cols-3 px-8">
        <div className="col-span-9 md:col-span-4">
          <ResumeCard
            duration="May 2024"
            title="Certificate of Presentation - IC3SE-2024"
            link="https://drive.google.com/file/d/1Jmz6iWxPWe5uWgmFt4SLCjE_3rUsc6GE/view?usp=sharing"
            subTitle="Amity University, India"
            des='Presented paper: "Voice of Hearing and Speech Impaired People" at the International Conference on Communication, Computer Sciences and Engineering.'
          />
          <ResumeCard
            duration="2022"
            title="Build AR Powered E-commerce Site Bootcamp"
            link="https://drive.google.com/file/d/1UtDaf7MAjQhqb05oze0MkZs9V5sX94BR/view?usp=sharing"
            subTitle="Open Weaver"
            des="Completed intensive bootcamp on building augmented reality powered e-commerce applications."
          />
          <ResumeCard
            duration="Jan 2022-Mar 2022"
            title="Server-side Development with NodeJS, Express and MongoDB"
            link="https://www.coursera.org/account/accomplishments/verify/CX65PMZU6LJQ"
            subTitle="Coursera"
            des="Unlock the world of server-side development with Node.js, Express, and MongoDB to build robust and scalable web applications."
          />
          <ResumeCard
            duration="Jan 2022-Mar 2022"
            title="Frontend Development With React"
            link="https://www.coursera.org/account/accomplishments/verify/9L2WMXPDJXU4"
            subTitle="Coursera"
            des="Discover the power of React.js to build dynamic user interfaces with React, mastering state management and component-based architecture."
          />
          <ResumeCard
            duration="Jan 2022-Mar 2022"
            title="HTML, CSS, and Javascript for Web Developers"
            link="https://www.coursera.org/account/accomplishments/verify/WFRE4Q2VMDV6"
            subTitle="Coursera"
            des="Learn the fundamentals of HTML, CSS, and JavaScript to master essential skills to build responsive and interactive websites."
          />
          <ResumeCard
            duration="2022"
            title="Python Programming | Numpy & Pandas"
            link="https://drive.google.com/file/d/1ehig8wyL9HupPD26qYsAZ3I-ncl_DPcE/view?usp=sharing"
            subTitle="Open Weaver"
            des="Dive into Python programming with a focus on NumPy and Pandas libraries to empower your data science and machine learning projects."
          />
          <ResumeCard
            duration="2022"
            title="Data Science Internship Completion"
            link="https://drive.google.com/file/d/1IWBrmmJkpO1HHu0Ijw-lrqk92lEHjxmR/view?usp=sharing"
            subTitle="ADDITECH-SIM"
            des="Successfully completed Data Science Internship focusing on machine learning model development and optimization."
          />
        </div>
      </div>
    </section>
  );
};

export default Education;
